import { ArrowRight, Clock } from "lucide-react";
import { useCompany, buildWhatsAppUrl } from "@/lib/useCompany";

const HERO_IMG =
  "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwd29vZGVuJTIwcGFsbGV0cyUyMHdhcmVob3VzZXxlbnwwfHx8fDE3Nzg4NDc2MzR8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const company = useCompany();

  return (
    <section
      data-testid="hero-section"
      className="relative pt-24 lg:pt-28 border-b-2 border-vp-yellow bg-vp-navy bg-pallet-grid"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 min-h-[80vh]">
        {/* Left: Text */}
        <div className="lg:col-span-7 px-6 lg:px-12 py-12 lg:py-20 flex flex-col justify-between border-r-0 lg:border-r-2 border-white/15">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-[2px] bg-vp-yellow" />
              <span className="label-industrial">
                B2B · Logística Industrial · 2020–2025
              </span>
            </div>

            <h1 className="heading-industrial text-[2.75rem] sm:text-6xl lg:text-[5.5rem] mb-8 text-white">
              Pallets que
              <br />
              sostienen
              <br />
              <span className="text-vp-yellow">tu operación.</span>
            </h1>

            <p className="text-lg sm:text-xl text-white/80 max-w-xl leading-relaxed">
              Cinco años proveyendo soluciones eficientes de compra y venta de
              pallets para la industria y logística local. Stock garantizado,
              calidad clasificada y entrega rápida para que tu cadena de
              suministro nunca se detenga.
            </p>
          </div>

          <div className="mt-12">
            <div className="flex flex-col sm:flex-row gap-0 sm:gap-0 border-2 border-vp-yellow w-fit">
              <a
                href={buildWhatsAppUrl(company.whatsapp)}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-whatsapp-cta"
                className="bg-vp-red hover:bg-[#b51e13] text-white font-bold uppercase tracking-widest text-sm px-8 py-5 inline-flex items-center gap-3 transition-colors"
              >
                Cotizar por WhatsApp
                <ArrowRight size={18} />
              </a>
              <a
                href="#cotizar"
                data-testid="hero-form-cta"
                className="bg-vp-yellow hover:bg-white text-[#001E62] font-bold uppercase tracking-widest text-sm px-8 py-5 inline-flex items-center gap-3 border-l-2 border-vp-yellow transition-colors"
              >
                Solicitar presupuesto
              </a>
            </div>
            <div className="mt-5 flex items-center gap-2 text-white/70 text-sm">
              <Clock size={14} className="text-vp-yellow" />
              <span>Respuestas en menos de 1 hora para compras corporativas.</span>
            </div>
          </div>
        </div>

        {/* Right: Image */}
        <div className="lg:col-span-5 relative bg-vp-navy-deep overflow-hidden min-h-[320px] lg:min-h-[640px]">
          <img
            src={HERO_IMG}
            alt="Bodega industrial con pallets apilados — Vigopal"
            className="absolute inset-0 w-full h-full object-cover opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#001E62]/80 via-[#001E62]/30 to-transparent" />

          <div className="absolute bottom-0 left-0 right-0 border-t-2 border-vp-yellow bg-vp-navy-deep px-6 py-5 flex items-center justify-between">
            <div>
              <div className="label-industrial">Patio Operativo</div>
              <div className="font-bold text-white mt-1">
                STOCK DISPONIBLE
              </div>
            </div>
            <div className="text-right">
              <div className="heading-industrial text-3xl text-vp-yellow">
                10K+
              </div>
              <div className="label-industrial">Pallets movilizados</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
